import React from "react";
import cn from "classnames";

import { CardProps } from "./Card.props";
import styles from "./Card.module.scss";

/**
 * @deprecated use `import { Panel } from "capitalrx-components-2.0/lib/general"
 */
const Card: React.FC<CardProps> = ({ children, id, testId, className }: CardProps): JSX.Element => {
  const cardStyles = cn(styles.Card, className);

  return (
    <div className={cardStyles} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </div>
  );
};

export default Card;
